import { useEffect, useState } from "react";
import { History, Loader2, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { money } from "@/lib/format";

const when = (iso) => new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
const onl = (v) => (v === null || v === undefined ? "" : v ? "online" : "teller only");

function ChangeLine({ c, city, i }) {
  const fareChanged = c.old_fare !== c.new_fare;
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-t border-slate-100 py-1.5 text-sm" data-testid={`fare-change-line-${i}`}>
      <span className="font-semibold">{city(c.from_id)} → {city(c.to_id)}</span>
      <span className="text-xs">
        {c.old_fare === null ? <b>{money(c.new_fare)}</b> : fareChanged ? <><s className="text-slate-400">{money(c.old_fare)}</s> → <b>{money(c.new_fare)}</b></> : <b>{money(c.new_fare)}</b>}
        {c.old_online !== c.new_online && <span className="ml-2 inline-flex items-center gap-1 text-slate-500"><Globe className="h-3 w-3" />{c.old_online === null ? onl(c.new_online) : `${onl(c.old_online)} → ${onl(c.new_online)}`}</span>}
      </span>
    </div>
  );
}

export function FareHistoryButton({ route, city }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  useEffect(() => { if (open) { setItems(null); api.get(`/admin/routes/${route.id}/fare-history`).then((r) => setItems(r.data)); } }, [open, route.id]);
  return (
    <>
      <Button size="icon" variant="ghost" title="Fare history" onClick={() => setOpen(true)} data-testid={`routes-fare-history-${route.id}`}><History className="h-4 w-4" /></Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[85vh] overflow-y-auto rounded-3xl sm:max-w-xl" data-testid="fare-history-dialog">
          <DialogHeader><DialogTitle className="font-display">Fare history · {route.name}</DialogTitle></DialogHeader>
          {!items ? <Loader2 className="mx-auto h-5 w-5 animate-spin" /> : !items.length
            ? <p className="text-sm text-slate-500" data-testid="fare-history-empty">No fare changes recorded yet. Changes are logged from now on.</p>
            : items.map((h) => (
              <div key={h.id} className="card-soft p-4" data-testid={`fare-history-entry-${h.id}`}>
                <div className="mb-1 flex flex-wrap items-center justify-between gap-2">
                  <span className="text-sm font-bold">{h.by_name} <span className="text-xs font-semibold capitalize text-slate-500">({h.by_role.replace("_", " ")})</span></span>
                  <span className="text-xs text-slate-500">{when(h.created_at)}{h.created ? " · created" : ""}</span>
                </div>
                {h.changes.map((c, i) => <ChangeLine key={i} c={c} city={city} i={i} />)}
              </div>
            ))}
        </DialogContent>
      </Dialog>
    </>
  );
}
